import type { Invite, WorksiteMember, WorksiteWorker } from "@/adapters/api";
import type { TeamRole } from "@/features/onboarding/types";
import type { PendingInvite, TeamMember, Worker } from "../types";

export function toTeamMember(member: WorksiteMember): TeamMember {
	return {
		userId: member.user_id,
		name: member.name,
		email: member.email,
		role: member.role as TeamRole | "",
		joinedAt: member.joined_at,
	};
}

export function toWorker(worker: WorksiteWorker): Worker {
	return {
		id: worker.id,
		name: worker.name,
		jobTitle: worker.job_title ?? "",
		role: (worker.role ?? "") as TeamRole | "",
		userId: worker.user_id,
		userEmail: worker.user_email ?? "",
		timeClockEnabled: worker.time_clock_enabled,
		active: worker.deactivated_at == null,
		deactivatedAt: worker.deactivated_at,
		createdAt: worker.created_at,
	};
}

export function toPendingInvite(invite: Invite): PendingInvite {
	return {
		id: invite.id,
		email: invite.email,
		role: invite.role,
		worksiteId: invite.worksite_id,
		status: invite.status,
		expiresAt: invite.expires_at,
		createdAt: invite.created_at,
	};
}
